import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { RoleFormSchemaValues } from 'src/features/roles/utils/formSchema';
import { rolesMessages } from 'src/features/roles/utils/messages';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';

type RoleFormProps = {
    form: UseFormReturn<RoleFormSchemaValues>;
    onSubmit: (values: RoleFormSchemaValues) => void;
};

function RoleForm({ onSubmit, form }: RoleFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<RoleFormSchemaValues> form={form} name="name" label={formatMessage(rolesMessages.name)} />
        </Form>
    );
}

export default RoleForm;
